module.exports = "<p>\n  polling-data works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/polling-data/polling-data.component.html
// module id = ./src/app/polling-data/polling-data.component.html
// module chunks = main